// STIGMA — Theme JavaScript

// Sticky header shrink
(function () {
  const header = document.getElementById('main-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      header.classList.add('py-2', 'editorial-shadow');
      header.classList.remove('py-stack-md');
    } else {
      header.classList.remove('py-2', 'editorial-shadow');
      header.classList.add('py-stack-md');
    }
  }, { passive: true });
})();

// Image fade-in
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('img').forEach(img => {
    img.classList.add('stigma-img');
    if (img.complete) {
      img.classList.add('loaded');
    } else {
      img.addEventListener('load', () => img.classList.add('loaded'));
    }
  });
});

// Accordion
function toggleAccordion(btn) {
  const item = btn.closest('.accordion-item');
  const isActive = item.classList.contains('active');
  document.querySelectorAll('.accordion-item.active').forEach(el => el.classList.remove('active'));
  if (!isActive) item.classList.add('active');
}

// Mobile menu toggle
(function () {
  const btn = document.getElementById('mobile-menu-btn');
  const menu = document.getElementById('mobile-menu');
  if (!btn || !menu) return;
  btn.addEventListener('click', () => {
    menu.classList.toggle('hidden');
  });
})();


// Add to cart form
(function () {
  const form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('[data-add-to-cart-btn]');
    const originalText = btn.textContent;
    btn.textContent = 'Προστέθηκε ✓';
    btn.disabled = true;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1,
        }),
      });
      CartDrawer.open();
    } catch (err) {
      console.error('Add to cart failed', err);
    }

    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2000);
  });
})();

// ─── Cart Drawer ─────────────────────────────────────────────────────────────

const CartDrawer = (function () {
  let FREE_THRESHOLD = 15000;
  let emptyUrl   = '/collections/all';
  let emptyLabel = 'Συνέχισε τις αγορές';

  let overlay, drawer, itemsEl, countEl, totalEl, shippingEl;

  function money(cents) {
    return new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function updateBadge(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  function renderShipping(total) {
    if (!shippingEl) return;
    const left = FREE_THRESHOLD - total;
    if (left <= 0) {
      shippingEl.innerHTML = `
        <p class="font-label-caps text-[11px] text-secondary uppercase tracking-widest flex items-center justify-center gap-1.5">
          <span class="material-symbols-outlined text-[15px]">check_circle</span>
          Δικαιούστε δωρεάν μεταφορικά!
        </p>`;
    } else {
      const pct = Math.min(100, Math.round((total / FREE_THRESHOLD) * 100));
      shippingEl.innerHTML = `
        <div class="flex justify-between font-label-caps text-[10px] uppercase text-on-surface-variant mb-1.5">
          <span>Δωρεάν Μεταφορικά</span>
          <span>Υπολείπονται <span class="text-primary">${money(left)}</span></span>
        </div>
        <div class="w-full h-1 bg-surface-variant rounded-full overflow-hidden">
          <div class="h-full bg-primary-container rounded-full transition-all duration-700" style="width:${pct}%"></div>
        </div>`;
    }
    shippingEl.classList.remove('hidden');
  }

  function renderItems(cart) {
    countEl.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
    totalEl.textContent = money(cart.total_price);
    renderShipping(cart.total_price);
    updateBadge(cart.item_count);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div class="flex flex-col items-center justify-center h-full text-center px-8 py-16">
          <span class="material-symbols-outlined text-outline mb-6 text-[56px]">shopping_bag</span>
          <p class="font-body-lg text-on-surface-variant mb-8">Το καλάθι σου είναι άδειο.</p>
          <a href="${emptyUrl}" class="font-label-caps text-label-caps uppercase tracking-widest text-primary border-b border-primary pb-0.5 hover:opacity-70 transition-opacity">
            ${emptyLabel}
          </a>
        </div>`;
      return;
    }

    itemsEl.innerHTML = `<div class="px-6 divide-y divide-outline-variant/20">` +
      cart.items.map((item, idx) => {
        const lineIndex = idx + 1;
        const img = item.image ? `<img src="${item.image}" alt="${item.product_title}" class="w-full h-full object-cover">` : '';
        const variant = item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="font-body-md text-[13px] text-on-surface-variant mt-0.5">${item.variant_title}</p>` : '';
        return `
          <div class="flex gap-4 py-5" data-line-index="${lineIndex}">
            <a href="${item.url}" class="shrink-0 w-20 aspect-[3/4] overflow-hidden bg-surface-container-low block">${img}</a>
            <div class="flex-grow flex flex-col justify-between min-w-0">
              <div class="flex justify-between items-start gap-2">
                <div class="min-w-0">
                  <p class="font-label-caps text-[10px] text-on-surface-variant uppercase truncate">${item.vendor}</p>
                  <h3 class="font-body-md text-[15px] text-on-surface leading-tight mt-0.5">
                    <a href="${item.url}" class="hover:text-primary transition-colors">${item.product_title}</a>
                  </h3>
                  ${variant}
                </div>
                <button type="button" data-drawer-remove="${lineIndex}" aria-label="Remove" class="text-on-surface-variant/40 hover:text-error transition-colors shrink-0">
                  <span class="material-symbols-outlined text-[18px]">close</span>
                </button>
              </div>
              <div class="flex items-center justify-between mt-3">
                <div class="flex items-center border border-outline-variant/30">
                  <button type="button" data-qty-change="decrease" class="w-8 h-8 flex items-center justify-center hover:bg-surface-container transition-colors">
                    <span class="material-symbols-outlined text-[16px]">remove</span>
                  </button>
                  <span data-qty-value class="w-8 text-center font-label-caps text-label-caps">${item.quantity}</span>
                  <button type="button" data-qty-change="increase" class="w-8 h-8 flex items-center justify-center hover:bg-surface-container transition-colors">
                    <span class="material-symbols-outlined text-[16px]">add</span>
                  </button>
                </div>
                <p class="font-body-md text-[15px] text-primary">${money(item.final_line_price)}</p>
              </div>
            </div>
          </div>`;
      }).join('') + `</div>`;
  }

  async function refresh() {
    itemsEl.innerHTML = `
      <div class="flex items-center justify-center h-32">
        <span class="material-symbols-outlined text-outline animate-spin text-[28px]">progress_activity</span>
      </div>`;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderItems(cart);
    } catch {
      itemsEl.innerHTML = `<p class="text-center text-on-surface-variant py-8 font-body-md px-6">Σφάλμα φόρτωσης καλαθιού.</p>`;
    }
  }

  async function changeQty(lineIndex, newQty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: newQty }),
      });
      renderItems(await res.json());
    } catch (err) {
      console.error('Cart update failed', err);
    }
  }

  function open() {
    overlay.classList.remove('opacity-0', 'pointer-events-none');
    overlay.classList.add('opacity-100');
    drawer.classList.remove('translate-x-full');
    drawer.classList.add('translate-x-0');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    refresh();
  }

  function close() {
    overlay.classList.add('opacity-0', 'pointer-events-none');
    overlay.classList.remove('opacity-100');
    drawer.classList.add('translate-x-full');
    drawer.classList.remove('translate-x-0');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  function init() {
    overlay   = document.getElementById('cart-overlay');
    drawer    = document.getElementById('cart-drawer');
    itemsEl   = document.getElementById('cart-drawer-items');
    countEl   = document.getElementById('cart-drawer-count');
    totalEl   = document.getElementById('cart-drawer-total');
    shippingEl = document.getElementById('cart-drawer-shipping');

    if (!drawer) return;

    // Read settings baked in by Liquid
    FREE_THRESHOLD = parseInt(drawer.dataset.freeThreshold || '15000', 10);
    emptyUrl       = drawer.dataset.emptyUrl   || '/collections/all';
    emptyLabel     = drawer.dataset.emptyLabel || 'Συνέχισε τις αγορές';

    document.getElementById('cart-drawer-close')?.addEventListener('click', close);
    overlay?.addEventListener('click', close);
    document.getElementById('cart-trigger')?.addEventListener('click', open);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

    itemsEl.addEventListener('click', async e => {
      const removeBtn = e.target.closest('[data-drawer-remove]');
      if (removeBtn) {
        await changeQty(parseInt(removeBtn.dataset.drawerRemove, 10), 0);
        return;
      }
      const qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        const row = qtyBtn.closest('[data-line-index]');
        if (!row) return;
        const lineIndex = parseInt(row.dataset.lineIndex, 10);
        const cur = parseInt(row.querySelector('[data-qty-value]')?.textContent ?? '1', 10);
        const delta = qtyBtn.dataset.qtyChange === 'increase' ? 1 : -1;
        await changeQty(lineIndex, Math.max(0, cur + delta));
      }
    });
  }

  return { init, open, close };
})();

document.addEventListener('DOMContentLoaded', () => CartDrawer.init());
